import store from '@/store';

export function getTooltipPositionByWindowWidth(tooltipWidth, position) {
  const { windowWidth } = store.getters;

  if (windowWidth >= tooltipWidth) {
    return 'is-right';
  }

  return position;
}

export function getTooltipPositionByContentWidth(tooltipWidth, position) {
  const { windowWidth, sidebarWidth } = store.getters;
  const widthWithoutSidebar = windowWidth - sidebarWidth;

  if (widthWithoutSidebar >= tooltipWidth) {
    return 'is-right';
  }

  return position;
}
